import type { ComponentProps, ReactNode } from 'react';

import { AlertLabel } from '../AlertLabel';
import { General } from '../StrokeIcons';

type InfoBoxProps = Omit<ComponentProps<'div'>, 'title'> & {
  title: string | ReactNode;
  icon?: ReactNode;
  type?: 'warning' | 'error';
};

export const InfoBox = ({ title, children, type, icon = <General.InfoCircle /> }: InfoBoxProps) => {
  return (
    <AlertLabel type={type ?? 'warning'} icon={icon} className="self-start">
      <strong>{title}</strong>
      {children}
    </AlertLabel>
  );
};
